/**
 * Created by rickborst on 22/02/2017.
 */

// Action types
const ActionTypes = {
    UPDATE_USER: "UPDATE_USER",
    UPDATE_USER_HOUSEHOLD_ID: "UPDATE_USER_HOUSEHOLD_ID",
    CLEAR_USER: "CLEAR_USER",
};

/**
 * Update user action.
 *
 * @param {Object} user - New user info.
 * @returns {Object} Action type and the new user info.
 */
function updateUser (user) {

    return {
        type: ActionTypes.UPDATE_USER,
        user: user
    };
}

function updateUserHouseholdId(id) {
    return {
        type: ActionTypes.UPDATE_USER_HOUSEHOLD_ID,
        id,
    };
}

/**
 * Clear user action.
 *
 * @returns {Object} Action type.
 */
function clearUser () {

    return {
        type: ActionTypes.CLEAR_USER
    };
}

export {
    ActionTypes,
    updateUser,
    updateUserHouseholdId,
    clearUser
};



// WEBPACK FOOTER //
// ./src/js/store/actions/user.js